import { observer } from "mobx-react";
import { RootState } from "../state/RootState";
import { IconButton, INavLink, INavLinkGroup, INavStyles, Nav, Stack, Text } from "@fluentui/react";

const navLinkGroups = (): INavLinkGroup[] => {
	let groups: INavLinkGroup[] = [];

	groups.push({
		links: [
			/*{
				name: 'Lists',
				url: `#${Pages.types}`,
				key: Pages.types,
				icon: 'FolderList',
				entityType: EntityType.EntityTypeDefinition,
			}*/
		]
	});

	return groups;
};

export const LeftNav = observer(({ rootState }: { rootState: RootState }) => {

	let fullVersionId = "v2602.24";
	let buildNumber = "{helmBuildNumber}"; //See github workflow file

	//Only append the build number if it's been set during the build process
	if(buildNumber.indexOf("{") === -1) {
		fullVersionId += "." + buildNumber;
	}

	const navStyles: Partial<INavStyles> = {
		root: {
			width: rootState.isNavCollapsed ? 47 : 150,
			marginTop: 3,
			overflowY: 'auto',
			link: rootState.isNavCollapsed && {
				paddingLeft: 9,
			},
		}
	};

	let navLinkGroupsValue = navLinkGroups();

	return (
		<Stack>
			<Nav
				className="mainNavClass"
				onLinkClick={(ev?: React.MouseEvent<HTMLElement>, item?: INavLink) => {
					rootState.setRoute(item?.url || '');
				}}
				selectedKey={rootState.hash}
				ariaLabel="Navigation"
				styles={navStyles}
				groups={navLinkGroupsValue}
			/>

			<IconButton iconProps={{iconName: rootState.isNavCollapsed ? 'ChevronRightMed' : 'ChevronLeftMed'}} onClick={() => rootState.toggleIsNavCollapsed()}></IconButton>

			<Text style={{margin:4, fontSize:9}}>{fullVersionId}</Text>
		</Stack>
	);
});
